





















































































































































































































































































































































































































































import { CrudService } from "../core/services/crudService";
import { Settings, TenantSettings } from "../core/services/configService";
import Vue from "vue";
import Component from "vue-class-component";
import { LocalStorage } from "../core/localStorage";
import { Format } from "../core/helpers/formatHelper";
import { ModifyMode } from "../core/constants";
import { ShopService } from "../core/services/shopService";
import InputText from "../components/form/inputText.vue";
import InputPassword from "../components/form/inputPassword.vue";
import CreditCardForm from "../components/form/creditCardForm.vue";
import { SaleItem } from "../core/interfaces/saleItem";
import Popup from "../components/popup/popup.vue";
import Checkbox from "../components/form/checkBox.vue";
import BaseSelect from "../components/form/baseSelect.vue";
import CzButton from "../components/cz/CzButton.vue";
import CzIcon from "../components/cz/CzIcon.vue";
import CheckoutPayment from "./checkoutPayment.vue";
import { notifyScrollTop } from "../core/embed";

@Component({
  components: {
    InputText,
    InputPassword,
    Popup,
    Checkbox,
    CreditCardForm,
    BaseSelect,
    CzButton,
    CzIcon,
    CheckoutPayment,
  },
})
export default class CheckoutPage extends Vue {
  settings: TenantSettings = {};
  error: string = "";
  data: any = null;
  transport: any = null;
  errors: any = {};
  paymentMethodId: number | null = null;
  reloadErrors: number = 0;
  voucherSelections: any = {};
  stepIndex: number = 0;
  payLink: any = null;

  get identified() {
    return this.$store.state.loggedIn || this.payLink !== null;
  }
  pendingBooking: any = null;

  // Pasos del checkout. "Datos" solo aparece si hace falta dirección/transporte.
  // CodeScanner registration of the dynamic step labels:
  // $t("Cart") $t("Your details") $t("Payment")
  get steps() {
    const arr: any[] = [{ key: "cart", label: "Cart" }];
    if (this.needsDetails) {
      arr.push({ key: "details", label: "Your details" });
    }
    arr.push({ key: "payment", label: "Payment" });
    return arr;
  }

  get needsDetails() {
    if (this.data === null) {
      return false;
    }
    return this.showDeliveryInfo() || this.checkTransportRequired();
  }

  get currentKey() {
    const steps = this.steps;
    const idx = this.stepIndex < steps.length ? this.stepIndex : steps.length - 1;
    return steps[idx] ? steps[idx].key : "cart";
  }

  goToStep(i: number) {
    // El indicador solo permite volver a pasos anteriores; avanzar es con "Continuar".
    if (i > this.stepIndex) {
      return;
    }
    this.setStep(i);
  }

  goNext() {
    // No avanzar al pago sin los datos de envío obligatorios.
    if (this.currentKey === "details" && !this.validateDetails()) {
      this.$store.commit(
        "openGlobalError",
        this.error || this.$t("Check required fields").toString()
      );
      return;
    }
    if (this.stepIndex < this.steps.length - 1) {
      this.setStep(this.stepIndex + 1);
    }
  }

  validateDetails() {
    this.errors = {};
    this.error = "";
    const msg = this.$t("Check required fields").toString();
    const transportRequired = this.checkTransportRequired();
    let ok = true;

    if (transportRequired || !this.identified) {
      const required = [
        "name",
        "surname",
        "addressLine1",
        "city",
        "town",
        "country",
        "postalCode",
        "email",
        "phone",
      ];
      for (const field of required) {
        if (Format.IsNull(this.data[field])) {
          this.$set(this.errors, field, msg);
          this.error = msg;
          ok = false;
        }
      }
    }

    if (!this.identified) {
      if (Format.IsNull(this.data.password)) {
        this.$set(this.errors, "password1", msg);
        this.error = msg;
        ok = false;
      } else if (this.data.password !== this.data.password2) {
        const pwMsg = this.$t("Password does not match").toString();
        this.$set(this.errors, "password1", pwMsg);
        this.$set(this.errors, "password2", pwMsg);
        this.error = pwMsg;
        ok = false;
      }
    }

    if (
      transportRequired &&
      (this.transport === null || this.transport === undefined)
    ) {
      this.error = this.$t("Please select transport").toString();
      ok = false;
    }

    this.reloadErrors++;
    return ok;
  }

  goPrev() {
    if (this.stepIndex > 0) {
      this.setStep(this.stepIndex - 1);
    }
  }

  setStep(i: number) {
    this.stepIndex = i;
    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (e) {
      window.scrollTo(0, 0);
    }
    notifyScrollTop();
  }

  async mounted() {
    this.settings = this.$store.state.settings;
    if (!Format.IsNull(this.$route.query.pay)) {
      return this.loadPayLink(this.$route.query.pay as string);
    }
    this.pendingBooking = LocalStorage.getWithTimeout("pendingBooking");

    let cid = null;
    let sid = LocalStorage.getWithTimeout("cc");
    if (sid !== undefined && sid !== null) {
      cid = JSON.parse(sid).id;
    }

    if (this.pendingBooking !== null && cid !== null) {
      const redirected = await this.preBookPending(cid);
      if (redirected) {
        return;
      }
    }

    const cart = this.$store.state.cart;
    if (cart === null || cart === undefined || cart.count === 0) {
      if (this.pendingBooking === null && Format.IsNull(this.error)) {
        return this.goToBookingTypes();
      }
      if (this.pendingBooking !== null && this.$store.state.loggedIn === false) {
        this.$store.commit("openLogin", {
          backUrl: this.$route.path,
          message: this.loginBenefitsMessage,
        });
      }
      return;
    }

    let i = 1;
    for (const saleItem of this.$store.state.cart.sItems) {
      saleItem.saleId = -1 * i; // saleId tmp to identify
      i++;
    }

    let url =
      cid == null
        ? `${Settings.HostName}/api/shop/checkout-info`
        : `${Settings.HostName}/api/shop/checkout-info-by-customer`;

    let data = await new CrudService().httpPost(url, {
      customerId: cid,
      saleItems: this.$store.state.cart.sItems,
      saleIds: this.$store.state.cart.sales.map((y) => y.id),
    });

    if (data == null || data === undefined) {
      console.error("Crash getting checkout info " + cid);
      if (data.ok === false) {
        console.error(data.errorMsg);
      }
      return;
    }

    this.data = data.data;
    if (data.data === null) {
      console.error(data.errorMsg);
      return;
    }

    if (
      this.data.transports !== null &&
      this.data.transports !== undefined &&
      this.data.transports.length > 0
    ) {
      this.transportRowClick(this.data.transports[0]);
    }
  }

  async loadPayLink(token: string) {
    const res = await new CrudService().httpPost(
      `${Settings.HostName}/api/shop/pay-link-info`,
      { token }
    );
    if (res === null || res === undefined || !res.ok) {
      this.error = (res && res.errorMsg) || this.$t("Crash").toString();
      return;
    }
    if (res.sales.length === 0) {
      this.error = this.$t("This payment has already been made").toString();
      return;
    }

    const shopService = new ShopService();
    shopService.removeCart();
    for (const sale of res.sales) {
      shopService.addSaleToCart(sale, null);
    }
    this.payLink = { token, customerId: res.customerId };
    this.data = res.data;
    // Show the payment concept in the cart before continuing to payment.
    this.setStep(0);
  }

  // Guest selection saved at the bookings page: prebook it now that there is a customer.
  async preBookPending(cid: number) {
    const pending = this.pendingBooking;
    LocalStorage.delete("pendingBooking");
    this.pendingBooking = null;

    const booking: any = {
      customerId: cid,
      bookingTypeId: pending.bookingTypeId,
      bookingTypeName: pending.bookingTypeName,
      isValidated: false,
      sendCommunications: false,
      origin: 0,
      bookingByPlace: pending.byPlace,
      isRemote: pending.isRemote === true,
    };
    for (const block of pending.blocks) {
      block.customerId = cid;
    }

    const res = await new CrudService().httpPost(
      `${Settings.HostName}/api/publicbookings/prebook`,
      {
        booking,
        customerIsParticipant: true,
        blocks: pending.blocks,
        isMultiple: false,
      }
    );

    if (res === undefined) {
      return false;
    }
    if (res == null) {
      this.error = this.$t("Crash").toString();
      return false;
    }
    if (res.ok === false) {
      this.error =
        res.model !== undefined && res.model !== null
          ? Object.values(res.model).join(", ")
          : res.errorMsg;
      return false;
    }
    if (res.model.serviceFree === true) {
      this.$router.push("/customer-bookings");
      return true;
    }

    const sale = res.model;
    sale.title = sale.description;
    sale.cancelUrl = `publicbookings/cancel/${sale.bookingId}/${cid}`;
    new ShopService().addSaleToCart(sale, null);
    return false;
  }

  openLoginPopup(register: boolean) {
    LocalStorage.add("loginModeOn", register);
    this.$store.commit("openLogin", {
      backUrl: this.$route.path,
      message: this.loginBenefitsMessage,
    });
  }

  get loginBenefitsMessage() {
    return (
      this.$t("Register or log in to enjoy all your advantages").toString() +
      ". " +
      this.$t(
        "Special prices and discounts are applied once you log in"
      ).toString()
    );
  }

  get cartCount() {
    const cart = this.$store.state.cart;
    return cart !== null && cart !== undefined ? cart.count : 0;
  }

  get pendingBookingLabel() {
    if (
      this.pendingBooking === null ||
      Format.IsNull(this.pendingBooking.blocks) ||
      this.pendingBooking.blocks.length === 0
    ) {
      return "";
    }
    const block = this.pendingBooking.blocks[0];
    return `${block.sstart} · ${block.duration}${this.$t("mins")}`;
  }

  async removeSaleFromCart(e: any, saleId: number) {
    e.preventDefault();
    await new ShopService().removeSaleFromCart(saleId);
    this.redirectIfEmpty();
  }

  async removeSaleItemFromCart(e: any, saleItem: any) {
    e.preventDefault();
    await new ShopService().removeSaleItemFromCart(saleItem);
    this.redirectIfEmpty();
  }

  incrementUnits(sItem: SaleItem) {
    new ShopService().modifyUnits(ModifyMode.Increment, sItem, 1);
  }

  async decrementUnits(sItem: SaleItem) {
    await new ShopService().modifyUnits(ModifyMode.Decrement, sItem, 1);
    this.redirectIfEmpty();
  }

  async modifyUnits(sItem: SaleItem) {
    const units = Number(sItem.units);
    if (isNaN(units)) {
      return;
    }
    await new ShopService().modifyUnits(ModifyMode.Exact, sItem, units);
    this.redirectIfEmpty();
  }

  // Sin nada en el carro ni reserva pendiente, volver a la selección de reservas.
  redirectIfEmpty() {
    const cart = this.$store.state.cart;
    if (
      (cart === null || cart === undefined || cart.count === 0) &&
      this.pendingBooking === null
    ) {
      this.goToBookingTypes();
    }
  }

  goToBookingTypes() {
    if (this.$route.path !== "/bookingtypes") {
      this.$router.push("/bookingtypes").catch(() => {});
    }
  }

  showDeliveryInfo() {
    // Solo pedir dirección de envío cuando hay transporte real (producto físico),
    // o cuando es un invitado (necesita registrarse). Un servicio no lleva envío.
    return !this.identified || this.checkTransportRequired();
  }

  checkTransportRequired() {
    const cart = this.$store.state.cart;
    if (cart === null || cart === undefined) {
      return false;
    }
    return cart.sItems.some(
      (y) => y.units > 0 && y.product.transportRequired === true
    );
  }

  getImagePath(img: string) {
    if (img === null || img === undefined || img === "") {
      return this.settings.Uploads + "/" + this.settings.Mainlogo;
    }
    return this.settings.Uploads + "/" + img;
  }

  formatPrice(price: string) {
    return Format.formatCurrency(price);
  }

  getSaleDeposit(saleId: number) {
    const deposits = this.data !== null ? this.data.deposits : null;
    if (!deposits || deposits.length === 0) {
      return null;
    }
    const deposit = deposits.find((y: any) => y.saleId === saleId);
    return deposit && deposit.depositAmount > 0 ? deposit.depositAmount : null;
  }

  hasVoucher(saleId: number) {
    return (
      this.data !== null &&
      this.data.vouchers !== null &&
      this.data.vouchers !== undefined &&
      this.data.vouchers.length !== 0 &&
      this.data.vouchers.find((y) => y.saleId === saleId) !== undefined
    );
  }

  getVoucherSelection(saleId: number) {
    const key = String(saleId);
    if (this.voucherSelections[key] !== undefined) {
      return this.voucherSelections[key];
    }
    return "";
  }

  setVoucherSelection(saleId: number, value: any) {
    const key = String(saleId);
    this.$set(this.voucherSelections, key, value);
  }

  getSaleItemVoucherOptions(saleId: number) {
    if (this.data === null || this.data.vouchers === null) {
      return [];
    }
    const saleVoucher = this.data.vouchers.find((y) => y.saleId === saleId);
    if (saleVoucher === undefined || saleVoucher === null) {
      return [];
    }
    return saleVoucher.vouchers.map((voucher: any) => {
      return { value: voucher.voucherId, label: voucher.name };
    });
  }

  getSaleVoucherOptions(saleId: number) {
    if (this.data === null || this.data.vouchers === null) {
      return [];
    }
    const saleVoucher = this.data.vouchers.find((y) => y.saleId === saleId);
    if (saleVoucher === undefined || saleVoucher === null) {
      return [];
    }
    return saleVoucher.vouchers.map((voucher: any) => {
      return { value: voucher.voucher.id, label: voucher.name };
    });
  }

  transportRowClick(transport: any) {
    const dom = document.getElementById("trans_" + transport.id);
    if (dom !== null && dom !== undefined) dom.click();
    this.transport = transport;
  }

  async payVoucher(sale: any, saleItem: any, saleId: number) {
    this.error = "";

    let cid = 0;
    let sid = LocalStorage.getWithTimeout("cc");
    if (sid !== undefined && sid !== null) {
      cid = JSON.parse(sid).id;
    }
    if (this.payLink !== null) {
      cid = this.payLink.customerId;
    }

    const selectedValue = this.getVoucherSelection(saleId);
    const vouchers = this.data.vouchers.find(
      (y) => y.saleId === saleId
    ).vouchers;

    let paymentMethodId = -1;
    let voucherId = -1;

    if (selectedValue === "" || selectedValue === null || selectedValue === undefined) {
      // is only one option
      paymentMethodId = vouchers[0].id;
      voucherId = vouchers[0].voucher.id;
    } else {
      voucherId = Number(selectedValue);
      for (const v of vouchers) {
        if (v.voucher.id === voucherId) {
          paymentMethodId = v.id;
        }
      }
    }

    let url = this.payLink
      ? `${Settings.HostName}/api/shop/checkout-pay-link`
      : `${Settings.HostName}/api/shop/checkout-customer`;

    const data = await new CrudService().httpPost(url, {
      token: this.payLink ? this.payLink.token : undefined,
      saleIds: sale !== null && sale !== undefined ? [sale.id] : null,
      saleItems:
        saleItem !== null && saleItem !== undefined ? [saleItem] : null,
      paymentMethodId: paymentMethodId,
      voucherId: voucherId,
      customer: {
        id: cid,
      },
    });

    const errorMsg = this.$t(
      "Ups! Tecnical problems. Please try again in a few minutes"
    ).toString();

    if (data == null || data === undefined) {
      console.error("Crash checkout " + cid);
      this.error = errorMsg;
      return;
    }

    if (data.ok === false || data.errors !== undefined) {
      this.error = data.model.errorMsg !== "" ? data.model.errorMsg : errorMsg;
      return;
    }

    const shopService = new ShopService();
    if (saleItem !== null && saleItem !== undefined) {
      shopService.removeSaleItemFromCart(saleItem);
    }

    if (saleId > 0) {
      shopService.removeSaleFromCart(saleId, false);
    }

    if (!Format.IsNull(data.model) && !Format.IsNull(data.model.saleNumber)) {
      // partial payment with money voucher, reload sale bc it is not fully paid
      shopService.addSaleToCart(data.model, null);
      this.$router.go(0);
      return;
    }

    if (this.$store.state.cart.count === 0) {
      return this.$router.push("/cz/ok");
    }
    location.href = "/checkout";
  }
}
